import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {SYSTEM_CATEGORY_EXTERNAL_NAME} from 'schemas/schema-interface/util/schemaFieldsetName';
import getSchemaInterfaceType from 'schemas/schema-interface/v2/getSchemaInterfaceType';
import {assertNever} from 'util/Types';

export default function getSchemaInterfaceMetadata(interfaceId: string): string | null {
  const interfaceType = getSchemaInterfaceType(interfaceId);
  switch (interfaceType) {
    case DomainGraphType.FIELDSET:
      return null; // This is the default, so no special label is necessary
    case DomainGraphType.STATIC_SCHEMA_INTERFACE:
      return SYSTEM_CATEGORY_EXTERNAL_NAME;
    default:
      throw Error(`Invalid interface type: ${assertNever(interfaceType)}`);
  }
}
